/**
 * Created by will on 6/30/14.
 */
var feedback = angular.module('feedback', ['classy', 'feedbackModel']);
feedback.classy.controller({
    name: 'FeedbackController',
    inject: ['$scope', 'FeedbackModelService', 'authServiceFactory', '$timeout', 'SliderService', 
        'StandardModalCudFactory', '$location', '$modalInstance'],
    init: function () {
        this.$.$modalInstance = this.$modalInstance;
        this.$.SliderService = this.SliderService;
        this.item = {}; 
        this.item.url = this.$location.$$path;
        this.item.userEmail = this.authServiceFactory.getAuth().userEmail;
        this.item.schoolID = this.authServiceFactory.getAuth().schoolID;
        this.$.modalCud = new this.StandardModalCudFactory(this.FeedbackModelService,
            this.authServiceFactory.getAuth().schoolID, this.item, this, [], this.index, this.$modalInstance);
        this.$.item.fromName = this.authServiceFactory.getAuth().firstName + ' ' + this.authServiceFactory.getAuth().lastName
        this.$.item.userAgent = navigator.userAgent;
        this.$.item.slider = this.SliderService.getHeader();
        this.$.item.url = this.$location.path();
        this.$.item.version = versionNo;
    },
    startSaveProcess: function(scope, instance, form){
        if (form.$valid)
        {
            instance.options.factor  = .3;
            this.FeedbackModelService.post(this.authServiceFactory.getAuth().schoolID, this.$.item, instance);
        }
        else
        {
            instance.stop(-1);
        }
    },
    closeFeedback: function()
    {
        var parent = this;
        this.$timeout(function() {
            parent.$modalInstance.dismiss('done')
        }, 800);
    }

});


feedback.service('FeedbackModalService', function($modal){

    var result = {}
    result.initModal = function()
    {
        return $modal.open({
            templateUrl: "fast/submodules/schoolside/feedback/feedback.html?v=" + versionNo,
            controller: "FeedbackController"
        });
    }
    return result;
});